import React from 'react';
import './socialbar.css';
import SocialMedia from './SocialMedia/SocialMedia';


const Socialbar = () => {
    return (
        <div className="social-bar d-none d-md-block pl-5">
            <SocialMedia/>
        </div>
    );
};

export default Socialbar;